import {
  gsap,
} from 'gsap';
import {
  ScrollTrigger,
} from 'gsap/ScrollTrigger';
import './components/heads-turning/heads-turning';
import './components/continuous-rotation/continuous-rotation';
import './components/machine-types/machine-types';
import './components/intuitive-interface/intuitive-interface';
import {
  isDebugMode,
  preloadAll,
  preloaderElements,
} from '@components/sections/preloader/preloader';

gsap.registerPlugin(ScrollTrigger);

// Initialize list of images.
const largeAssetBreakpoint = window.matchMedia('(min-width: 800px)');
const sources = Array.from({
  length: 140,
}).map((_, i) => `/_ui/skin/src/img/360-rotating/${largeAssetBreakpoint.matches ? '1400' : '800'}/asset-${i.toString().padStart(4, '0')}.webp`);
const incrementOffset = 1 / sources.length;
const percentLoaded = {
  value: 0,
};

// Each image should increment progress bar.
const preloadImageCallback = () => {
  gsap.set(preloaderElements.progress, {
    scaleX: `+=${incrementOffset}`,
    x: `+=${incrementOffset}`,
  });
  gsap.set(percentLoaded, {
    value: `+=${incrementOffset}`,
    onComplete() {
      preloaderElements.percent.textContent = Math.min(Math.ceil(percentLoaded.value * 100), 100);
    },
  });
};

// Preload all images in set.
let loadedImages = [];

// Initialize canvas and images and stuff.
const canvas = document.getElementById('rotating-360');
const context = canvas.getContext('2d');

canvas.width = largeAssetBreakpoint.matches ? 1400 : 800;
canvas.height = largeAssetBreakpoint.matches ? 1400 : 800;
const frameCount = 140;

const sequence = {
  frame: 0,
};
const render = () => {
  if (loadedImages.length) {
    if (sequence.frame >= frameCount) {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(loadedImages[frameCount - 1], 0, 0);
    } else {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(loadedImages[sequence.frame], 0, 0);
    }
  }
};

const initialPageHashScroll = () => {
  ScrollTrigger.refresh();
  if (window.location.hash.length) {
    const windowHash = window.location.hash.slice(1);

    gsap.set(window, {
      scrollTo: {
        y: 0,
      },
    });

    // If section exists, scroll to it.
    const foundElement = document.getElementById(windowHash);
    if (foundElement) {
      let sectionToScroll = window.location.hash;
      // Testimonial slide!
      if (foundElement.hasAttribute('data-hash')) {
        sectionToScroll = '#testimonials';
      }
      gsap.timeline()
        .set(window, {
          scrollTo: {
            y: 0,
          },
        })
        .set(window, {
          scrollTo: {
            y: sectionToScroll,
            offsetY: -10,
          },
        });
    }
  }
};

const finishPreloading = () => {
  // Init ScrollTriggers.
  // Fade in/out.
  ScrollTrigger.create({
    trigger: '#features',
    start: 'top center',
    fastScrollEnd: true,
    onEnter() {
      gsap.to(canvas, { autoAlpha: 1, duration: 0.5 });
    },
    onLeaveBack() {
      gsap.to(canvas, { autoAlpha: 0, duration: 0.5 });
    },
  });

  // Update frames!
  ScrollTrigger.create({
    trigger: '#features',
    start: '+=200vh',
    // end: 'bottom bottom+=9000',
    end: 'bottom bottom+=5000',
    fastScrollEnd: true,
    onUpdate(self) {
      const { progress } = self;
      sequence.frame = Math.floor(progress * sources.length);
      render();
    },
  });

  // Finish up the progress state.
  gsap.timeline()
    .to(preloaderElements.progress, {
      scaleX: 1,
      duration: 0.2,
      onStart() {
        gsap.to(preloaderElements.container, { color: '#FF5405', duration: 0.2 });
      },
      onComplete() {
        document.body.classList.remove('preloader-active');
        render();
        initialPageHashScroll();
      },
    })
    .to(preloaderElements.container, {
      autoAlpha: 0,
      display: 'none',
      duration: 0.5,
    });
};

if (isDebugMode()) {
  finishPreloading();
}

// Preload all images in set.
preloadAll(sources, preloadImageCallback)
  .then((finishedImages) => {
    loadedImages = finishedImages;
  })
  .catch(() => {

  })
  .finally(() => {
    finishPreloading();
  });
